module.exports = __webpack_public_path__ + "static/media/layout-three-1.d8a286a7.jpg";